import React, { useRef, useEffect, useState } from "react";
import "./Projects.css";

import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  CaretRightOutlined,
  PauseOutlined,
} from "@ant-design/icons";
import ProjectsCart from "../Cart/ProjectsCart";

import Img1 from "../Img/Screenshot 1.png";
import Img2 from "../Img/Screenshot 2.png";
import Img3 from "../Img/Screenshot 3.png";
import Img4 from "../Img/Screenshot 4.png";
import Img5 from "../Img/Screenshot 5.png";
import Img6 from "../Img/Screenshot 6.png";
import Img7 from "../Img/Screenshot 7.png";
import Img8 from "../Img/Screenshot 3.1.png";
import Img9 from "../Img/Screenshot 8.png";
import Img10 from "../Img/Screenshot 10.png";
import Img11 from "../Img/Screenshot 11.png";
import Img12 from "../Img/Screenshot 12.png";
import Img13 from "../Img/Screenshot 13.png";
import Img14 from "../Img/Screenshot 14.png";
import Img15 from "../Img/Screenshot 15.png";
import Img16 from "../Img/Screenshot 16.png";
import Img17 from "../Img/Screenshot 17.png";



export default function Projects() {
  const containerRef = useRef(null);
  const [isAutoScrolling, setIsAutoScrolling] = useState(true);
  const [scrollDirection, setScrollDirection] = useState(1);

  useEffect(() => {
    let intervalId;

    if (isAutoScrolling) {
      intervalId = setInterval(() => {
        const container = containerRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;
        let newScrollLeft;

        if (scrollDirection === 1) {
          newScrollLeft = container.scrollLeft + 200;
          if (newScrollLeft >= maxScrollLeft) {
            newScrollLeft = 0;
          }
        } else {
          newScrollLeft = container.scrollLeft - 200;
          if (newScrollLeft <= 0) {
            newScrollLeft = maxScrollLeft;
          }
        }

        container.scrollTo({
          left: newScrollLeft,
          behavior: "smooth",
        });
      }, 2000);
    }

    return () => clearInterval(intervalId);
  }, [isAutoScrolling, scrollDirection]);

  const toggleAutoScrolling = () => {
    setIsAutoScrolling((prev) => !prev);
  };

  const scrollLeft = () => {
    setScrollDirection(-1);
  };

  const scrollRight = () => {
    setScrollDirection(1);
  };

  return (
    <div className="Projects-Body">
      <div className="Projects-Box">
        <div className="Projects-Div1">
          <div className="Projects-Div2">
            <p className="Projects-Text1">|| Projects</p>
            <p className="Projects-Text2">My Complete Projects.</p>
          </div>
          <div className="Projects-Div3">
            <button className="Projects-Div3-button" onClick={scrollLeft}>
              <DoubleLeftOutlined />
            </button>
            <button
              className="Projects-Div3-button2"
              onClick={toggleAutoScrolling}
            >
              {isAutoScrolling ? <CaretRightOutlined /> : <PauseOutlined />}
            </button>
            <button className="Projects-Div3-button" onClick={scrollRight}>
              <DoubleRightOutlined />
            </button>
          </div>
        </div>
        <div className="Projects-Cart-Container" ref={containerRef}>
          <div className="Projects-Cart-Box">
            <ProjectsCart
              Img={Img1}
              Text1="Smira Club Web"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React / NodeJS / Material UI"
              Link1="https://smira.club"
              Link2="https://github.com/sazzad9911/simira-club-ui/"
            />
            <ProjectsCart
              Img={Img2}
              Text1="Smira Club Aps"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React Native / NodeJS / Material UI"
              Link1="https://play.google.com/store/apps/details?id=com.smira.users"
              Link2="https://github.com/sazzad9911/simira-club-ui/"
            />
            <ProjectsCart
              Img={Img3}
              Text1="Advanced Binary Code Limited"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React / NodeJS / Material UI"
              Link1="https://ab-company-limited.web.app"
              Link2="https://github.com/akashsdk/company-web"
            />
            <ProjectsCart
              Img={Img4}
              Text1="Online Shop"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React / NodeJS / Material UI"
              Link1="https://online-shopsbd.web.app/"
              Link2="https://github.com/akashsdk/onlineshop"
            />
            <ProjectsCart
              Img={Img5}
              Text1="Scientistx"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React / NodeJS / Material UI"
              Link1="http://www.scientistx.org/"
              Link2="https://github.com/Nahiduzzamann/scientistx-technology"
            />
            <ProjectsCart
              Img={Img6}
              Text1="Greenery [Fiverr Projects]"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React / NodeJS / Tailwind CSS"
              Link1="https://greenery-tree.web.app/"
              Link2="https://github.com/akashsdk/fiverr-4"
            />
            <ProjectsCart
              Img={Img7}
              Text1="courier services [Up-Coming]"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React / NodeJS / Material UI"
              Link1=""
              Link2="https://github.com/akashsdk/fiverr-three"
            />
            <ProjectsCart
              Img={Img8}
              Text1="Smart Street Light [University Project]"
              Text2="Front-End & Back-End Developer"
              Text3="HTML & CSS / React / NodeJS / Material UI"
              Link1="https://smart-street-light-e3189.web.app/"
              Link2="https://github.com/akashsdk/street-light"
            />
            <ProjectsCart
              Img={Img9}
              Text1="CinemarooBD"
              Text2="Front-End Developer"
              Text3="HTML & CSS / React / NodeJS / Tailwind CSS"
              Link1="https://cinemaroo-bd.web.app/"
              Link2="https://github.com/akashsdk/fiverr-five"
            />
            <ProjectsCart
              Img={Img10}
              Text1="Vision Care [Fiverr Projects]"
              Text2="Front-End Developer"
              Text3="HTML & CSS / NextJS / NodeJS / Tailwind CSS"
              Link1="https://vision-care.vercel.app/"
              Link2="https://github.com/akashsdk/fivver-seven"
            />
            <ProjectsCart
              Img={Img11}
              Text1="ShaplaMart [E-Commerce]"
              Text2="Front-End & Back-End Developer"
              Text3="HTML & CSS / NextJS / NodeJS / Tailwind CSS"
              Link1="https://shaplamart.vercel.app/"
              Link2="https://github.com/akashsdk/shaplamart"
            />
            <ProjectsCart
              Img={Img14}
              Text1="Forxtrader [Trading Sites]"
              Text2="Front-End"
              Text3="HTML & CSS / NextJS / Tailwind CSS"
              Link1="https://www.forxtrader.com/"
              Link2="https://github.com/akashsdk"
            />
            <ProjectsCart
              Img={Img15}
              Text1="Tarfi Founaion"
              Text2="Front-End & Back-End Developer"
              Text3="HTML & CSS / NextJS / NodeJS / Tailwind CSS"
              Link1="https://tarafi-foundation.vercel.app"
              Link2="https://github.com/akashsdk"
            />
            <ProjectsCart
              Img={Img12}
              Text1="Sports Buzzs [Blog Sites]"
              Text2="Front-End & Back-End Developer"
              Text3="HTML & CSS / NextJS / NodeJS / Tailwind CSS"
              Link1="https://www.sportsbuzzs.com/"
              Link2="https://github.com/akashsdk"
            />
            <ProjectsCart
              Img={Img13}
              Text1="Darkak [E-Commerce]"
              Text2="Front-End & Back-End Developer"
              Text3="HTML & CSS / NextJS / NodeJS / Tailwind CSS"
              Link1="https://www.darkak.com.bd"
              Link2="https://github.com/akashsdk"
            />
            <ProjectsCart
              Img={Img16}
              Text1="Donate Blood"
              Text2="Front-End & Back-End Developer"
              Text3="HTML & CSS / NextJS / NodeJS / Tailwind CSS"
              Link1="https://bloodbond-bd.web.app"
              Link2="https://github.com/akashsdk"
            />
            <ProjectsCart
              Img={Img17}
              Text1="Jhotpot Pay"
              Text2="Front-End & Back-End Developer"
              Text3=" NextJS / React Native / NodeJS / Tailwind CSS"
              Link1="https://www.jhotpotpay.com"
              Link2="https://github.com/akashsdk"
            />
          </div>
        </div>
        <div className="Projects-Div4">
          <button className="Projects-Div3-button" onClick={scrollLeft}>
            <DoubleLeftOutlined />
          </button>
          <button
            className="Projects-Div3-button2"
            onClick={toggleAutoScrolling}
          >
            {isAutoScrolling ? <CaretRightOutlined /> : <PauseOutlined />}
          </button>
          <button className="Projects-Div3-button" onClick={scrollRight}>
            <DoubleRightOutlined />
          </button>
        </div>
      </div>
    </div>
  );
}
